/* eslint-disable no-shadow */
export enum RothPortionEnum {
  none = "None",
  some = "Some",
  all = "All"
}
/* eslint-enable no-shadow */
